/**
 * Third-party script loader
 * PERF/CONSENT (A3):
 *  - Consent comes from window.dscfConsent (theme.liquid), which reads Shopify's Customer Privacy API.
 *    The previous check called a function that does not exist, so everything always loaded.
 *  - Nothing here loads before the first user interaction, so these
 *    scripts no longer compete with the first tap.
 *  - Tally only loads on pages that actually contain a Tally embed.
 */
(function () {
  'use strict';

  // Bing UET is loaded by GTM (tag 32007924); the theme copy was a duplicate and has been removed.
  var SCRIPTS = {
    tally: {
      src: 'https://tally.so/widgets/embed.js',
      consent: null, // functional: it renders forms the visitor asked to see
      when: function () {
        return !!document.querySelector('[data-tally-src], iframe[src*="tally.so"], a[href*="tally.so"], [data-tally-open]');
      }
    }
  };

  function hasConsent(type) {
    if (!type) return true;
    if (window.dscfConsent && typeof window.dscfConsent.allowed === 'function') {
      return window.dscfConsent.allowed(type);
    }
    return true;
  }

  function loadScript(config) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[src="' + config.src + '"]')) return resolve();
      var s = document.createElement('script');
      s.src = config.src;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('Failed to load: ' + config.src)); };
      document.head.appendChild(s);
    });
  }

  function loadOne(config) {
    if (config.when && !config.when()) return;
    var go = function () { loadScript(config).catch(function () {}); };
    if (!config.consent) return go();
    if (window.dscfConsent && typeof window.dscfConsent.when === 'function') {
      window.dscfConsent.when(config.consent, go);
    } else if (hasConsent(config.consent)) {
      go();
    }
  }

  var started = false;
  function loadAll() {
    if (started) return;
    started = true;
    Object.keys(SCRIPTS).forEach(function (name) { loadOne(SCRIPTS[name]); });
  }

  // First interaction only (no timer), so nothing here lands in the page-load window.
  var events = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
  function onFirstInteraction() {
    events.forEach(function (e) { window.removeEventListener(e, onFirstInteraction, { passive: true }); });
    setTimeout(loadAll, 50);
  }
  events.forEach(function (e) { window.addEventListener(e, onFirstInteraction, { passive: true, once: true }); });

  window.ThirdPartyLoader = {
    loadScript: loadScript,
    hasConsent: hasConsent,
    loadScriptsByPriority: loadAll
  };
})();
